/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WeatherMoonIcon16Light = forwardRef('WeatherMoonIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.376 1.592a.776.776 0 0 1 .02.835 4.5 4.5 0 0 0 6.178 6.178.776.776 0 0 1 .834.02c.238.159.405.475.293.828A6.5 6.5 0 1 1 6.547 1.3a.727.727 0 0 1 .83.293Zm-1.14.894a5.501 5.501 0 1 0 7.278 7.278 5.5 5.5 0 0 1-7.278-7.278Z" })));
});
